<template>
  <div class="orderList">
    <Delivery ref="send" @success="refreshCurrentList"/>
    <FilterForm :fields="searchFields" @submit="search"/>
    <ConfirmRefund ref="confirmRefund" @success="refreshCurrentList" />
    <QueryLogistcs ref="queryLogistcs"/>
    <BasicTable
      showSelect
      border
      hasOperate
      customClass="table"
      :pageSize="+pageOption.page_size"
      :currentPage="+pageOption.page"
      :total="+pageOption.total"
      :tableData="tableData"
      @pageChange="pageChange"
      :treeProps="{ children: 'sub', hasChildren: 'hasChildren' }"
      :columns="columns" >
      <template slot="tableOpeate">
        订单列表&emsp;
      </template>
      pay_type
      <template v-slot:order_status="{ item }">
        {{orderStatus.get(item.order_status)}}
      </template>
      <template v-slot:pay_type="{ item }">
        {{item.pay_type === 0 ? '微信支付' : '预支付'}}
      </template>
      <template v-slot:operate="{ item }">
        <div class="btns">
          <AppButton v-if="item.order_status === 0" type="primary" class="btn" plain size="small" @click="modifyAmount(item)">修改价格</AppButton>
          <AppButton v-if="item.order_status === 0 || item.order_status === 2" type="primary" class="btn" plain size="small" @click="rejectOrder(item)">驳回订单</AppButton>
          <AppButton v-if="item.pay_type === 1 && item.order_status === 0" type="primary" class="btn" plain size="small" @click="advanceCharge(item)">预付款确认收款</AppButton>
          <AppButton type="primary" class="btn" plain size="small" @click="openDetail(item)">订单详情</AppButton>
          <AppButton v-if="item.order_status >= 3" type="primary" class="btn" plain size="small" @click="orderLogistics(item)">物流查询</AppButton>
          <AppButton v-if="item.order_status === 6" type="primary" class="btn" plain size="small" @click="confirmRefund(item)">确认收到退货</AppButton>
          <AppButton v-if="item.order_status === 6 || item.order_status === 7" type="primary" class="btn" plain size="small" @click="refund(item)">退款/货确认</AppButton>
          <AppButton v-if="item.order_status === 2" type="primary" class="btn" plain size="small" @click="send(item)">订单发货</AppButton>
          <AppButton v-if="item.return_check === 1 && [0,2,4].indexOf(item.order_return) > -1" type="primary" class="btn" plain size="small" @click="confirmRefundAmount(item)">退款</AppButton>
          <AppButton v-if="item.order_status === -1" type="primary" class="btn" plain size="small" @click="delOrder(item)">删除订单</AppButton>
        </div>
      </template>
      </BasicTable>
  </div>
</template>

<script>
import { OrderService } from '../../service/order.service';
import { MessageBox } from 'element-ui';
import Delivery from './delivery.vue';
import ConfirmRefund from './confirmRefund.vue';
import QueryLogistcs from './queryLogistics.vue';

const orderStatus = new Map([
    [0, '未付款'],
    [2, '已付款'],
    [3, '发货中'],
    [4, '订单完成'],
    [6, '退货中'],
    [7, '退款中'],
    [8, '退款完成'],
    [9, '付款中'],
    [-1, '订单关闭/订单过期'],
]);
const payTypes = new Map([['wx', '微信'], ['ali', '支付宝'], ['other', '其他']]);
const columns = [
  { name: '订单编号', key: 'order_sn' },
  { name: '收货人', key: 'consignee'},
  { name: '订单状态', key: 'order_status', type: 'custom' },
  { name: '订单总价', key: 'total_amount'},
  { name: '应付金额', key: 'order_amount'},
  { name: '支付方式', key: 'pay_type', type: 'custom'},
  { name: '下单时间', key: 'add_time'},
  { name: '操作', key: 'operate', type: 'custom', width: '300px' }
];
const searchFields = [
  { name: '搜索', placeholder: '订单编号/收货人', key: 'search', type: 'input' },
  { name: '开始时间', key: 'start_time', type: 'date' },
  { name: '结束时间', key: 'end_time', type: 'date' },
  { name: '支付状态', key: 'order_status', type: 'select' },
  { name: '支付方式', key: 'pay_way', type: 'select', options: [...payTypes.entries()].map(v => ({ label: v[1], value: v[0] })) },
  { name: '升降序', key: 'order_type', type: 'select', options: [{ label: '升序', value: 'asc' }, { label: '降序', value: 'desc' }] },
  { name: '订单状态', key: 'order_status', type: 'select', options: [...orderStatus.entries()].map(v => ({ label: v[1], value: v[0] })) },
];
export default {
    name: 'orderList',
    components: { Delivery, ConfirmRefund, QueryLogistcs },
    data() {
      return {
        tableData: [],
        columns,
        orderStatus,
        searchFields,
        payTypes,
        searchValues: {},
        loading: false,
        pageOption: {
          page: 1,
          page_size: 20,
          total: 0,
        }
      }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList(quertField) {
        const query = { ...quertField, page: this.pageOption.page, page_size: this.pageOption.page_size, order_status: 7 };
        const data = await OrderService.getList(query);
        this.tableData = data.list;
        this.pageOption.page = data.page;
        this.pageOption.total = data.totalRow;
      },
      refreshCurrentList() {
        // this.pageOption.page = 1;
        this.getList(this.searchValues);
      },
      search(data) {
        this.searchValues = data;
        this.getList(data);
      },
      async rejectOrder(item) {
        const { value } = await MessageBox.prompt(`请输入驳回原因` );
        await OrderService.reject(item.order_id, value);
        this.refreshCurrentList();
      },
      pageChange(index) {
        this.pageOption.page = index;
        this.getList(this.searchValues);
      },
      async delOrder(item) {
        await MessageBox.confirm('确定要删除订单吗？');
        await OrderService.delete(item.order_id);
        this.refreshCurrentList();
      },
      send(item) {
        this.$refs.send.open(item);
      },
      async openDetail(item) {
        this.$router.push({path:'/orderDetail',query:{data:item.order_id}})
        // const data = await OrderService.detail(item.order_id);
        // this.$refs.detail.open(data);
      },
      async advanceCharge(item) {
        await MessageBox.confirm('确认用户提交的预付款订单');
        await OrderService.advanceCharge({ order_id: item.order_id });
        this.refreshCurrentList();
      },
      refund(item) {
        this.$refs.confirmRefund.open(item);
      },
      async confirmRefund(item) {
        await MessageBox.confirm('确认收到退货？');
        await OrderService.refundCheck(item.order_id);
        this.refreshCurrentList();
      },
      async confirmRefundAmount(item) {
        await MessageBox.confirm(`确认后将退回【${item.return_price}元】金额到用户账户？`);
        await OrderService.refund(item.order_id);
        this.refreshCurrentList();
      },
      orderLogistics(item) {
        this.$refs.queryLogistcs.open(item);
      },
      async modifyAmount(item) {
        const { value } = await MessageBox.prompt(`输入总金额, 原付款总金额${item.total_amount} (元)` );
        await OrderService.editAmount(item.order_id, value);
        this.refreshCurrentList();
      },
      async deleteItem(item) {
        await MessageBox.confirm('确定要删除这个订单吗？', '删除订单');
        await OrderService.delete(item.order_id);
        this.refreshCurrentList();
      },
    }
  }
</script>

<style lang="scss" scoped>

.btns {
  
}
.btn {
  margin-bottom: 4px;
}
</style>